import { render, staticRenderFns } from "./ResearchCitationPanels.vue?vue&type=template&id=8c02d53e&scoped=true"
import script from "./ResearchCitationPanels.vue?vue&type=script&lang=js"
export * from "./ResearchCitationPanels.vue?vue&type=script&lang=js"
import style0 from "./ResearchCitationPanels.vue?vue&type=style&index=0&id=8c02d53e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c02d53e",
  null
  
)

export default component.exports